module.exports = __webpack_public_path__ + "assets/img/one-tab3-on.8315c001.png";